import React from 'react';
import { motion } from 'framer-motion';
import { useSiteContext } from '../../context/SiteContext';
import ReferenceCard from '../ui/ReferenceCard';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const FeaturedReferences = () => {
  const { data } = useSiteContext();
  const featured = data.websiteReferences
    .filter(ref => ref.active && ref.featured)
    .sort((a, b) => a.featuredRank - b.featuredRank)
    .slice(0, 9);

  if (!featured.length) return null;

  return (
    <section id="references" className="py-20 relative">
      <div className="w-full max-w-[1440px] 2xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <h2 className="text-3xl font-bold text-white mb-4">Featured Additions</h2>
            <p className="text-slate-400 max-w-2xl">
              Explore recent website references built for enquiries, professional presentation, and automated follow-up.
            </p>
          </div>
        </div>
        <motion.div
          className="reference-card-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {featured.map(reference => (
            <ReferenceCard key={reference.websiteId} reference={reference} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedReferences;